import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes } from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
    routes,
    //mode: 'history',
    //linkActiveClass: "active"    
    //linkActiveClass: 'has-current',
    //hashbang: false,
});
//router.mode ='html5';
//router.beforeEach(guardRoute);


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js